import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
  constructor() { }

  public exportExcel(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelFileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION, { bookType: 'xlsx', type: 'buffer' });
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  public exportAsExcelFileWithDate(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const now = new Date();

    // Shift so ISO string is based on local time
    const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000);

    // Get YYYYMMDD and HHmmss separately
    const iso = local.toISOString();
    const datePart = iso.slice(0, 10).replace(/-/g, "");  
    const timePart = iso.slice(11, 19).replace(/:/g, "");
    FileSaver.saveAs(data, excelFileName + '_export_' + datePart + '_' + timePart + EXCEL_EXTENSION);
  }

  public exportAsExcelFileWithDateWithoutExport(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const now = new Date();

    // Shift so ISO string is based on local time
    const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000);

    // Get YYYYMMDD and HHmmss separately
    const iso = local.toISOString();
    const datePart = iso.slice(0, 10).replace(/-/g, "");
    const timePart = iso.slice(11, 19).replace(/:/g, "");
    FileSaver.saveAs(data, excelFileName + datePart + '_' + timePart + EXCEL_EXTENSION);
  }

}
